import { axiosNoAuth, axiosConsumer } from "./axiosConsumer";

export const getSku = async (delivery_date: string, dealerId: string) => {
  const page = 1;
  const per_page = 10;
  const { data } = await axiosNoAuth.get(
    `/api/v1/unregistered-dealer-skus?page=${page}&per_page=${per_page}&delivery_date=${delivery_date}&dealerId=${dealerId}`
  );
  return data;
};

export const insertUnRegisterContractItem = async (
  payload: any,
  dealerId: string
) => {
  const { data } = await axiosNoAuth.post(
    `/api/v1/unregistered-contract?dealerId=${dealerId}`,
    payload
  );
  return data;
};

export const getUnRegisterPresignedURL = async (
  folderName: string,
  fileType: string,
  dealerId: string,
  fileExtension?: string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(
    `/api/v1/unregistered-contract-file-upload-url?dealerId=${dealerId}&folderName=${folderName}&fileType=${fileType}${
      fileExtension && "&fileExtension=" + fileExtension
    }`
  );
  return data;
};
